
const TableChoiceIsland = ({items, itemsShow, setItem}) => {

    const onClickRadio = (e) => {
        const idx = parseInt(e.target.value);
        setItem({...items.current.showed[idx]})
    };


    return (
        <table className="table table-striped">
            <thead>
            <tr>
                <th></th>
                <th key="name">Name</th>
                <th>Desciption</th>
            </tr>
            </thead>
            <tbody>
            {itemsShow.map((item, index) => (
                <tr key={index}>
                    <td><input type="radio" name="radioIslandContainer" value={index} onChange={onClickRadio}/></td>
                    <td >{item.name}</td>
                    <td >{item.description}</td>
                </tr>
            ))}
            </tbody>
        </table>
    );
}

export default TableChoiceIsland

